/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import React, { Fragment } from 'react'
import Donut from './ChartComponents/Donut'
import PropTypes from 'prop-types'
import List from '../../../components/List'
import DownCarot from '../../../assets/icons/carat.svg'

class PhysicalActivity extends React.Component {
  constructor(props) {
    super(props)

    // getinitialState
    this.state = {
      initData: this.donutData()
    }
  }

  UNSAFE_componentWillReceiveProps() {
    this.setState({
      initData: this.donutData()
    })
  }

  donutData() {
    const { details } = this.props
    let data = details

    if (
      !data.total.__ok ||
      !data.walking.__ok ||
      !data.vigorous.__ok ||
      !data.moderate.__ok
    ) {
      data.total.value = 0
      data.walking.value = 25
      data.vigorous.value = 50
      data.moderate.value = 25
    }

    return {
      centerValue: {
        value: data.total.value,
        label: data.total.unit
      },
      chartData: [
        {
          legend: data.walking.display_label,
          value: data.walking.value,
          label: data.walking.value + '  ' + data.walking.unit
        },
        {
          legend: data.vigorous.display_label,
          value: data.vigorous.value,
          label: data.vigorous.value + '  ' + data.vigorous.unit
        },
        {
          legend: data.moderate.display_label,
          value: data.moderate.value,
          label: data.moderate.value + '  ' + data.moderate.unit
        }
      ]
    }
  }

  render() {
    const { details, hotload, index } = this.props
    const items = {
      physicalActivity: {
        title: '<h2 class="mobile-padding">Physical Activity</h2>',
        icon: { src: DownCarot },
        isShowAccordianOnMobile: true,
        accordianContent: `
      <div class="mobile-padding">
            <div>
              <p class="noMarginPadding">
                Physical activity is assessed by the International Physical
                Activity Questionnaire (IPAQ), a validated survey used to
                estimate physical activity level and weekly energy expenditure.
              </p>
            </div>
            <br/>
          <div class="intro-title">
                International Physical Activity <br/> Questionnaire (IPAQ)
              </div>
              <br/>
          </div>`
      }
    }
    const listProps = {
      items,
      isMobile: this.props.isMobile,
      isNoTopBorder: true,
      isNotSpacer: true,
      isCollapsedDark: true,
      isReportStyle: true
    }

    return (
      <div className="overview-content module-content physical-content">
        <div className="intro-zone">
          {this.props.isMobile ? (
            <Fragment>
              <List {...listProps} />
              <div className="mobile-padding">
                <div className="intro-title">
                  Weekly Physical Activity Level{' '}
                </div>
                <span className="large-value">
                  {details.weekly_level.value}
                </span>
              </div>
              <br />
              <br />
            </Fragment>
          ) : (
            <div className="intro-flex">
              <div>
                <div className="intro-title">
                  Weekly Physical Activity Level{' '}
                </div>
                <span className="large-value">
                  {details.weekly_level.value}
                </span>
              </div>
              <div>
                <div className="intro-title">
                  International Physical Activity Questionnaire (IPAQ)
                </div>
                <p>
                  Physical activity is assessed by the International Physical
                  Activity Questionnaire (IPAQ), a validated survey used to
                  estimate physical activity level and weekly energy
                  expenditure.
                </p>
              </div>
            </div>
          )}
        </div>
        {!this.props.isMobile && <hr />}

        <div className="bucket mobile-padding">
          <div>
            {hotload ? (
              <Donut
                details={details}
                indentifier={'PhysAct'}
                index={index}
                data={this.state.initData}
                triggerMan={this.state.sizestate}
              />
            ) : null}
          </div>
          {!details.total.__ok ? (
            <div className="no-report-data">{`No Data Available`}</div>
          ) : null}
        </div>
      </div>
    )
  }
}

PhysicalActivity.propTypes = {
  details: PropTypes.object.isRequired
}

export default PhysicalActivity
